import { type Moment } from 'moment'

import { type Enum } from '@webapp/infrastructure/types/Enum'
import { type TravelTransportTypeEnum } from '@webapp/modules/expense/entities/enums/TravelTransportTypeEnum'

export const TravelTripTypes = {
  ONE_WAY: 'oneway',
  RETURN_TRIP: 'returntrip',
} as const

export type TravelTripType = Enum<typeof TravelTripTypes>

/**
 * A trip confirmed from the trip modal. In the create context trips are
 * captured client-side only (no API call) and mapped to the `destList`
 * payload at the submit boundary; one-way trips carry `returnDate: null`
 * and the payload mapper sets arrival = departure (BHV-017).
 */
export interface TripFormValue {
  transport: TravelTransportTypeEnum
  tripType: TravelTripType
  /** Committed only via Places suggestion selection (BHV-015) */
  departurePlace: google.maps.places.PlaceResult
  arrivalPlace: google.maps.places.PlaceResult
  /** Committed only via the calendar picker (BHV-015) */
  departureDate: Moment
  returnDate: Nullable<Moment>
}
